var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[(_vm.isLoading)?_c('v-progress-linear',{attrs:{"indeterminate":true,"color":"primary"}}):_c('GChart',{attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.chartOptions,"width":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }